import React, { memo, useCallback, useId, useState } from 'react';
import { ChevronDown16Regular } from '@fluentui/react-icons';
import BlockMarkdown from '../structured/BlockMarkdown';
import ComparisonTableBlock from '../structured/ComparisonTableBlock';
import ExpandableSectionBlock from '../structured/ExpandableSectionBlock';
import { MarkdownBlock, UnsupportedBlock } from '../structured/UnsupportedBlock';
import { extractBlockMarkdown } from '../structured/structuredBlockUtils';
import styles from './consultantReport.module.css';

function AppendixBlock({ block, renderContext }) {
    if (block.type === 'expandable_section') {
        return <ExpandableSectionBlock block={block} renderContext={renderContext} />;
    }
    if (block.type === 'comparison_table') {
        return <ComparisonTableBlock block={block} renderContext={renderContext} />;
    }
    if (block.type === 'markdown') {
        return <MarkdownBlock block={block} renderContext={renderContext} />;
    }
    return <UnsupportedBlock block={block} renderContext={renderContext} />;
}

function AppendixSection({ blocks, renderContext }) {
    const [expanded, setExpanded] = useState(false);
    const panelId = useId();
    const toggle = useCallback(() => setExpanded(value => !value), []);

    if (!blocks?.length) return null;

    return (
        <section className={styles.appendixPanel}>
            <button
                type="button"
                className={`${styles.appendixTrigger} noPrint`}
                aria-expanded={expanded}
                aria-controls={panelId}
                onClick={toggle}>
                <span>Appendix</span>
                <ChevronDown16Regular aria-hidden />
            </button>
            {expanded ? (
                <div id={panelId} className={styles.appendixBody}>
                    {blocks.map(block => {
                        const content = extractBlockMarkdown(block);
                        if (block.type === 'markdown' && content) {
                            return <BlockMarkdown key={block.id} content={content} {...renderContext} />;
                        }
                        return <AppendixBlock key={block.id} block={block} renderContext={renderContext} />;
                    })}
                </div>
            ) : null}
        </section>
    );
}

export default memo(AppendixSection);
